module.exports = __webpack_public_path__ + "static/img/jl.c8a88fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jl.png
// module id = peb8
// module chunks = 1